import * as constants from '@config/constants';

export const xhrKey = xhrRequest => {
  return `[${xhrRequest.method}] ${xhrRequest.url}`;
};

export const apiRequest = (xhrRequest, body) => ({
  key: xhrKey(xhrRequest),
  payload: {
    body,
    method: xhrRequest.method,
    url: xhrRequest.url,
  },
  type: constants.API_REQUEST,
});
